import { render, staticRenderFns } from "./cell-promo-code-type.vue?vue&type=template&id=4aa12e7e&scoped=true"
import script from "./cell-promo-code-type.ts?vue&type=script&lang=ts&external"
export * from "./cell-promo-code-type.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-promo-code-type.vue?vue&type=style&index=0&id=4aa12e7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa12e7e",
  null
  
)

export default component.exports